const BraveMeasureTextError = () => {
  return (
    <div data-testid="brave-measure-text-error">
      <p>
        <span style={{ fontWeight: 600 }}>Looks like you are using Brave browser</span> with the <span style={{ fontWeight: 600 }}>Aggressively Block Fingerprinting</span> setting enabled.
      </p>
      <p>
        This could result in breaking the <span style={{ fontWeight: 600 }}>Text Elements</span> in your drawings.
      </p>
      <p>
        We strongly recommend disabling this setting.
      </p>
    </div>
  );
};

export default BraveMeasureTextError;
